import React from 'react';

function Add2(props) {
    return (
        <div>2</div>
    );
}

export default Add2;